import React from 'react'

type FileIconProps = {
  color?: string
}

export default function ({ color = '#384A51' }: FileIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M13.291 5.787c-.007-.022-.013-.042-.022-.063-.032-.07-.073-.138-.13-.195l-4-4c-.058-.058-.125-.098-.196-.131-.02-.01-.04-.015-.062-.022-.056-.019-.114-.03-.173-.034-.015-.001-.027-.009-.041-.009H4c-.735 0-1.333.598-1.333 1.334v10.666c0 .736.598 1.334 1.333 1.334h8c.735 0 1.333-.598 1.333-1.334V6c0-.014-.007-.027-.008-.041-.004-.06-.015-.116-.034-.172zm-2.234-.454H9.333V3.61l1.724 1.724zm-7.057 8V2.667h4V6c0 .369.298.667.667.667H12l.001 6.666h-8z"
      />
    </svg>
  )
}
